"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Snackbar;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Snackbar = _interopRequireDefault(require("@mui/material/Snackbar"));
var _SnackbarContent = _interopRequireDefault(require("@mui/material/SnackbarContent"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Error = _interopRequireDefault(require("@mui/icons-material/Error"));
var _Done = _interopRequireDefault(require("@mui/icons-material/Done"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _mui = require("tss-react/mui");
var _colors = require("@mui/material/colors");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _mui.makeStyles)()(theme => ({
  success: {
    color: theme.palette.getContrastText(theme.palette.mode === "light" ? _colors.green[500] : _colors.green[200]),
    backgroundColor: theme.palette.mode === "light" ? _colors.green[500] : _colors.green[200]
  },
  info: {
    color: theme.palette.getContrastText(theme.palette.mode === "light" ? _colors.blue[500] : _colors.blue[200]),
    backgroundColor: theme.palette.mode === "light" ? _colors.blue[500] : _colors.blue[200]
  },
  error: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
}));
function Snackbar({
  t = text => text,
  isSnackbarOpen = false,
  closeSnackbar = () => {},
  snackbarMessage = "Default message",
  snackbarType = ""
}) {
  const {
    classes
  } = useStyles();
  let icon, color;
  if (snackbarType === "success") {
    icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Done.default, {
      className: classes.iconVariant
    });
    color = classes.success;
  } else if (snackbarType === "error") {
    icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Error.default, {
      className: classes.iconVariant
    });
    color = classes.error;
  } else {
    icon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Info.default, {
      className: classes.iconVariant
    });
    color = classes.info;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      position: "absolute"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Snackbar.default, {
      "aria-live": "assertive",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      open: isSnackbarOpen,
      autoHideDuration: 6000,
      onClose: closeSnackbar,
      message: snackbarMessage,
      "aria-describedby": "client-snackbar-message",
      role: "none",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SnackbarContent.default, {
        "data-cy": "snackbar",
        className: color,
        message: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          "aria-label": "client-snackbar-message",
          className: classes.message,
          role: "alert",
          children: [icon, t(snackbarMessage)]
        }),
        action: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          color: "inherit",
          onClick: closeSnackbar,
          size: "large",
          "aria-label": "Close",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
        }, "close")]
      })
    })
  });
}